<template>
	<div class="c-faq__accordion--wrapper">
		<div class="c-faq__accordion--inner">
			<v-faq-accordion-item 
				:item="item" 
				:category="category.faqCategory"
				:key="item.id" 
				:isDefaultQuestion="isDefaultQuestion(item)"
				v-for="(item, index) in category.items">
			</v-faq-accordion-item>
		</div>
	</div>
</template>

<script>
import VIcon from '../icon/VIcon.vue';
import VFaqAccordionItem from './VFaqAccordionItem.vue';

export default {
	name: "VFaqAccordion",
	components: { VIcon, VFaqAccordionItem },
	props: {
		questionId: {
			type: String,
			default: ''
		},
		category: {
			type: Object,
			default: () => {}
		}
	},
	methods: {
		isDefaultQuestion(item){
			return this.questionId === item.id;
		}
	}
};
</script>
